import { useState, useEffect } from "react";
import { MediaPlayer } from "./MediaPlayer";

function isVideo(url) {
  const ext = url.split("?")[0].split(".").pop().toLowerCase();
  return ["mp4", "webm", "ogg"].includes(ext);
}

export function Work() {
  const [media, setMedia] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");

  useEffect(() => {
    fetch("/api/getPortfolioMedia")
      .then((res) => res.json())
      .then((data) => {
        setMedia(data);
        setFiltered(data);
      })
      .catch((err) => console.error("Failed to load media:", err));
  }, []);

  const applyFilter = (filter) => {
    setActiveFilter(filter);
    if (filter === "all") {
      setFiltered(media);
    } else if (filter === "image") {
      setFiltered(media.filter((m) => m.type === "image"));
    } else if (filter === "video-horizontal") {
      setFiltered(
        media.filter((m) => m.type === "video" && m.resType === "horizontal")
      );
    } else if (filter === "video-vertical") {
      setFiltered(
        media.filter((m) => m.type === "video" && m.resType === "vertical")
      );
    }
  };

  // Podział na horizontale i verticale
  const horizontals = filtered.filter((m) => m.resType === "horizontal");
  const verticals = filtered.filter((m) => m.resType === "vertical");

  return (
    <div className="px-4">
      <h1 className="text-5xl text-white font-bold text-center mb-8">
        KAWAŁEK MOJEJ PRACY
      </h1>

      {/* Filtry */}
      <div className="flex justify-center gap-4 mb-10 flex-wrap">
        <button
          onClick={() => applyFilter("all")}
          className={`px-4 py-2 rounded-lg font-semibold transition ${activeFilter === "all"
            ? "bg-blue-600 text-white"
            : "bg-zinc-800 text-gray-300 hover:bg-zinc-700"
            }`}
        >
          Wszystkie
        </button>
        <button
          onClick={() => applyFilter("image")}
          className={`px-4 py-2 rounded-lg font-semibold transition ${activeFilter === "image"
            ? "bg-blue-600 text-white"
            : "bg-zinc-800 text-gray-300 hover:bg-zinc-700"
            }`}
        >
          Grafiki
        </button>
        <button
          onClick={() => applyFilter("video-horizontal")}
          className={`px-4 py-2 rounded-lg font-semibold transition ${activeFilter === "video-horizontal"
            ? "bg-blue-600 text-white"
            : "bg-zinc-800 text-gray-300 hover:bg-zinc-700"
            }`}
        >
          Filmy
        </button>
        <button
          onClick={() => applyFilter("video-vertical")}
          className={`px-4 py-2 rounded-lg font-semibold transition ${activeFilter === "video-vertical"
            ? "bg-blue-600 text-white"
            : "bg-zinc-800 text-gray-300 hover:bg-zinc-700"
            }`}
        >
          Shorts
        </button>
      </div>

      {/* Horizontale */}
      {horizontals.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-4xl mx-auto mb-10">
          {horizontals.map((item, i) => (
            <div
              key={"h-" + i}
              className="relative group w-full pb-[56.25%] bg-zinc-800 rounded-xl shadow-lg overflow-hidden cursor-pointer"
              onClick={() => setSelectedMedia(item)}
            >
              {isVideo(item.url) ? (
                <video
                  src={item.url}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="absolute top-0 left-0 w-full h-full object-cover rounded-xl"
                />
              ) : (
                <img
                  src={item.url}
                  alt={`Work horizontal ${i + 1}`}
                  className="absolute top-0 left-0 w-full h-full object-cover rounded-xl"
                />
              )}
              {item.description && (
                <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center text-white text-center px-4 text-lg font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl">
                  {item.description}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Verticale */}
      {verticals.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {verticals.map((item, i) => (
            <div
              key={"v-" + i}
              className="relative group w-full pb-[177.78%] bg-zinc-800 rounded-xl shadow-lg overflow-hidden cursor-pointer"
              onClick={() => setSelectedMedia(item)}
            >
              {isVideo(item.url) ? (
                <video
                  src={item.url}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="absolute top-0 left-0 w-full h-full object-cover rounded-xl"
                />
              ) : (
                <img
                  src={item.url}
                  alt={`Work vertical ${i + 1}`}
                  className="absolute top-0 left-0 w-full h-full object-cover rounded-xl"
                />
              )}
              {item.description && (
                <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center text-white text-center px-4 text-lg font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl">
                  {item.description}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {selectedMedia && (
        <MediaPlayer media={selectedMedia} onClose={() => setSelectedMedia(null)} />
      )}
    </div>
  );
}
